module.exports = __webpack_public_path__ + "static/hero-asian-cd7c852c25f36da68132c333c3eb0dfc.png";